import { DialogGenre, RowId } from "@/interfaces/common.interface";
import { ref, provide } from "vue";

/**
 * @function 新規登録/修正用ダイアログ
 */
export default function (name: string) {
  //Dialog.vueに渡す変数
  const dialogFormVisible = ref(false);
  const rowId = ref<RowId>(undefined);
  provide("dialogFormVisible", dialogFormVisible);
  provide("rowId", rowId);
  const dialogTitle = ref("");
  const dialogOperation = ref("");

  //ダイアログ開く（新規登録または修正）
  const openDialog = (opt: DialogGenre, id?: string) => {
    if (opt === DialogGenre.Add) {
      rowId.value = undefined;
      dialogTitle.value = `${name}登録`;
    } else {
      rowId.value = id;
      dialogTitle.value = `${name}修正`;
    }
    dialogOperation.value = opt;
    dialogFormVisible.value = true;
  };
  return {
    dialogTitle,
    dialogOperation,
    openDialog,
  };
}
